
import { Component, Vue } from 'vue-property-decorator'
import { getWarningsetList, addWarningset, putWarningset, delWarningset } from '@/api/warning'
import { IArticleData } from '@/api/types'
import { Form } from 'element-ui'

@Component({
  name: 'Table'
})
export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private title = '新增报警配置人员'
  private total = 0
  private sub = ''
  private listQuery = {
    page: 1,
    pagesize: 10,
    menber: ''
  }
  private initForm = {
    name: '',
    number: '',
    phone: '',
    type: '0',
    shortMessage: []
  }
  private rules = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' }
    ],
    phone: [
      { required: true, message: '请输入正确的手机号', trigger: 'blur' },
      { min: 11, max: 11, message: '请输入11位手机号', trigger: 'blur' }
    ]
  }
  private formData = { ...this.initForm }
  private formLabelWidth = '120px'

  created() {
    this.getList()
  }

  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getWarningsetList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 新增 修改
  private async changeHandel(row:any) {
    this.dialogFormVisible = true
    if (row) {
      this.title = '修改报警配置人员'
      this.sub = 'put'
      this.formData = row
    } else {
      this.title = '新增报警配置人员'
      this.sub = 'add'
      this.formData = this.initForm
    }
  }
  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      if (rule.field === 'imageURL') {
        this.$message({
          message: 'Upload cover image is required',
          type: 'error'
        })
      } else {
        this.$message({
          message: rule.field + ' is required',
          type: 'error'
        })
      }
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }
  private async submitHandle() {
    (this.$refs.formData as Form).validate(async(valid) => {
      if (valid) {
        if (this.sub === 'add') {
          const { data } = await addWarningset(this.formData)
          if (data) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
          }
        } else {
          const { data } = await putWarningset(this.formData)
          if (data) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
          }
        }
        this.dialogFormVisible = false
      }
    })
  }
  // 删除
  private async delHandel(id:any) {
    this.$confirm('确定要删除该配置人员？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = delWarningset({ id })
      if (res) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery.page = page
    this.getList()
  }
}
